import { render, staticRenderFns } from "./DataPreview.vue?vue&type=template&id=cb773094&"
import script from "./DataPreview.vue?vue&type=script&lang=js&"
export * from "./DataPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports